import React from 'react';
import { Check } from 'lucide-react';
import './Checkbox.scss';

interface Props {
  checked: boolean;
  onChange?: () => void;
  color: string;
  readOnly?: boolean;
}

const Checkbox: React.FC<Props> = ({ checked, onChange, color, readOnly = false }) => (
  <button
    onClick={readOnly ? undefined : onChange}
    className={`checkbox${checked ? ' checkbox--checked' : ''}${readOnly ? ' checkbox--readonly' : ''}`}
    style={{ '--checkbox-color': color } as React.CSSProperties}
    disabled={readOnly}
  >
    {checked && <Check size={12} color="#000" strokeWidth={3} />}
  </button>
);

export default Checkbox;
